import { useObserver } from "mobx-react";
import { useStores } from "../../store";
import defaultPic from "../../assests/userdefaultpic.jpeg";
import { IoPersonCircleOutline, IoRibbonOutline } from "react-icons/io5";
import { FaEye } from "react-icons/fa";

export default function TopTalentTable() {
  const { RecuiterStore, PopupStore } = useStores();
  const convertTimestampToDate = (timestamp) => {
    const date = new Date(timestamp); // Convert seconds to milliseconds
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  return useObserver(() => (
    <>
      <div className="flex items-center justify-center">
        <div
          className="bg-white rounded-lg shadow-md mb-14 md:mb-0  p-2 md:-mt-2 lg:-mt-2 mt-0
               md:h-[40vh] lg:w-full md:w-[59.3vw] w-[93%] mx-auto overflow-hidden"
          style={{
            scrollbarWidth: "none",
            boxShadow: "rgb(229 229 229) 0px 0px 60px 5px",
          }}
        >
          <h2 className="text-lg text-gray-800 gil-med -mb-2 flex gap-3 py-4 md:-mt-2 lg:-mt-2 mt-0">
            <span className="bg-primary2 p-2 mb-1 -mt-1 rounded-full">
              <IoRibbonOutline className="ml-1" />
            </span>
            Top Talent
          </h2>

          <div className="overflow-auto no-scrollbar max-h-[300px] md:max-h-none">
            <table className="w-full text-left table-fixed border-collapse">
              <thead className="w-full bg-white z-10">
                <tr className="bg-gray-100 rounded-lg">
                  <th className="px-4 py-2.5 hidden md:block text-center text-xs !rounded-l-lg text-black font-normal">
                    Profile
                  </th>
                  <th className="px-4 py-2.5 text-center text-black font-normal text-xs">
                    Name
                  </th>
                  <th className="px-4 py-2.5 text-center text-black font-normal text-xs">
                    Job Post
                  </th>
                  <th className="px-4 py-2.5 text-center text-black font-normal text-xs">
                    Score
                  </th>
                  <th className="px-4 py-2.5 text-center text-black font-normal text-xs md:table-cell hidden">
                    Date
                  </th>
                  <th className="px-4 py-2.5 text-center rounded-r-lg text-black font-normal text-xs">
                    Resume
                  </th>
                </tr>
              </thead>
            </table>
            <div className="overflow-y-scroll h-[25vh] md:h-[25vh] max-h-[300px] md:max-h-none no-scrollbar">
              <table className="w-full text-left table-fixed border-collapse">
                <tbody>
                  {RecuiterStore.topApplicants.length === 0 && (
                    <tr>
                      <td
                        colSpan="6"
                        className="text-center py-20 font-bold text-2xl text-primary"
                      >
                        No data found
                      </td>
                    </tr>
                  )}
                  {RecuiterStore.topApplicants
                    .slice(0, 4)
                    .map((candidate, index) => (
                      <tr key={index} className="border-b hover:bg-gray-50">
                        <td className="ml-10 py-2.5 hidden md:block text-center w-full flex justify-center items-center">
                          {candidate?.userId?.pic ? (
                            <img
                              src={candidate.userId.pic}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = defaultPic;
                              }}
                              alt="Profile"
                              className="w-10 h-10 rounded-full object-cover"
                            />
                          ) : (
                            <IoPersonCircleOutline className="w-10 h-10 text-gray-400" />
                          )}
                        </td>
                        <td className="px-4 py-2.5 text-center text-sm text-gray-500">
                          {candidate?.userId?.name}
                        </td>
                        <td className="px-4 py-2.5 text-center truncate text-sm text-gray-500 whitespace-nowrap">
                          {candidate.jobPostId?.jobTitle}
                        </td>
                        <td className="px-4 py-2.5 text-center text-sm text-gray-500">
                          {candidate.averageScore ? (Number(candidate.averageScore) || 0).toFixed(0) : 0}%
                        </td>
                        <td className="px-4 py-2.5 text-center text-sm text-gray-500 hidden md:table-cell">
                          {convertTimestampToDate(candidate.createdAt)}
                        </td>
                        <td className="px-4 md:px-6 py-2.5 text-center text-sm whitespace-nowrap">
                          <button
                            onClick={() => {
                              RecuiterStore.setPdfLink(candidate.resume);
                              PopupStore.setPdfView(true);
                            }}
                            className="text-orange-500 cursor-pointer hover:underline flex items-center justify-center"
                          >
                            <span className="hidden md:inline">
                              View Resume
                            </span>
                            <FaEye className="md:hidden ml-1" />
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  ));
}
